module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "media-pieces"
    }
  }, [(!_vm.singlePieceMode) ? [_c('vue-masonry', {
    attrs: {
      "min-width": 450,
      "horizontal-gutter": 40,
      "vertical-gutter": 40
    }
  }, [(_vm.canEdit && !_vm.editAlbumMode && !_vm.addPieceMode && !_vm.fetchingPieces && _vm.album) ? [_c('div', {
    staticClass: "media-post",
    attrs: {
      "id": "edit-album"
    },
    on: {
      "click": _vm.enterEditAlbumMode
    }
  }, [_c('i', {
    staticClass: "fas fa-pencil-alt"
  }), _c('span', [_vm._v("Edit Album")])]), _vm._v(" "), _c('div', {
    staticClass: "media-post",
    attrs: {
      "id": "add-media"
    },
    on: {
      "click": _vm.enterAddPieceMode
    }
  }, [_c('i', {
    staticClass: "fas fa-image"
  }), _c('span', [_vm._v("Add a Piece")])])] : _vm._e(), _vm._v(" "), _vm._l((_vm.pieces), function(piece) {
    return (!_vm.editAlbumMode && !_vm.addPieceMode && !_vm.fetchingPieces && _vm.album) ? _c('media-post', {
      attrs: {
        "piece": piece,
        "medias-id": _vm.mediasId,
        "can-edit": _vm.canEdit
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.piecesCount === 0 && !_vm.editAlbumMode && !_vm.addPieceMode && !_vm.fetchingPieces && _vm.album) ? _c('div', {
    staticClass: "media-post no-media-message"
  }, [_vm._v("This Album is empty")]) : _vm._e(), _vm._v(" "), (_vm.fetchingPieces && _vm.album) ? _c('div', [_c('loader-large')], 1) : _vm._e(), _vm._v(" "), (_vm.editAlbumMode) ? _c('edit-album-form', {
    attrs: {
      "album": _vm.album,
      "mediasId": _vm.mediasId
    }
  }) : _vm._e()], 2), _vm._v(" "), (_vm.addPieceMode) ? _c('new-piece-form', {
    attrs: {
      "album": _vm.album,
      "page-type": _vm.pageType,
      "page-id": _vm.pageId
    },
    on: {
      "doneEditing": function($event) {
        _vm.addPieceMode = false
      }
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.singlePieceMode) ? _c('single-piece-listing', {
    attrs: {
      "album": _vm.album,
      "pieces": _vm.pieces,
      "medias-id": _vm.mediasId,
      "can-edit": _vm.canEdit
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69b15c0e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/Media/MediaPieceList.vue
// module id = 883
// module chunks = 2